/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import localforage from "localforage";
import { useAgencyInfo } from "context/agency";
import GhlLogo from "assets/images/ssssss.png";
import SoftAvatar from "components/SoftAvatar";
import env from "config/env";
import { useNavigate, useParams } from "react-router-dom";

function Accounts() {
  const CUSTOM_URL = env.CUSTOM_URL
  const { email, locationId } = useParams();
  const [agency, , , , , handleRefresh] = useAgencyInfo()
  const [copy, setcopy] = useState(false);
  const [sessionkey, setsessionkey] = useState("");
  const navigate = useNavigate();
  // const url = agency?.domain
  //   ? `https://${agency?.domain}/maybe_connection/${agency?._id}`
  //   : `${CUSTOM_URL}/maybe_connection/${agency?._id}`;
  const url = `https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${env.GHL.REDIRECT.AGENCY}&client_id=${env.GHL.CLIENT_ID}&scope=businesses.readonly%20businesses.write%20calendars.write%20calendars.readonly%20calendars/groups.readonly%20calendars/groups.write%20calendars/resources.readonly%20calendars/resources.write%20calendars/events.readonly%20calendars/events.write%20campaigns.readonly%20contacts.readonly%20contacts.write%20conversations.readonly%20conversations.write%20conversations/message.readonly%20conversations/message.write%20forms.readonly%20invoices.readonly%20invoices.write%20invoices/schedule.readonly%20invoices/schedule.write%20invoices/template.readonly%20invoices/template.write%20links.readonly%20links.write%20locations.readonly%20locations.write%20locations/customValues.readonly%20locations/customValues.write%20locations/customFields.readonly%20locations/customFields.write%20locations/tags.readonly%20locations/tags.write%20locations/templates.readonly%20locations/tasks.readonly%20medias.readonly%20medias.write%20funnels/redirect.readonly%20funnels/redirect.write%20funnels/page.readonly%20funnels/funnel.readonly%20funnels/pagecount.readonly%20opportunities.readonly%20opportunities.write%20payments/integration.readonly%20payments/integration.write%20payments/orders.readonly%20payments/orders.write%20payments/transactions.readonly%20payments/subscriptions.readonly%20products.readonly%20products.write%20products/prices.readonly%20products/prices.write%20oauth.readonly%20oauth.write%20saas/location.write%20saas/location.read%20saas/company.write%20snapshots.readonly%20socialplanner/account.readonly%20socialplanner/account.write%20socialplanner/csv.readonly%20socialplanner/csv.write%20socialplanner/category.readonly%20socialplanner/oauth.readonly%20socialplanner/oauth.write%20socialplanner/post.readonly%20socialplanner/post.write%20socialplanner/tag.readonly%20surveys.readonly%20users.readonly%20users.write%20workflows.readonly%20courses.write&state=${agency?._id}`

  const handlecopy = () => {
    setcopy(true);

    setTimeout(() => {
      setcopy(false);
    }, 2000);
  };
  const getSession = async () => {
    const sess = await localforage.getItem("sessionkey");
    // alert(sess);
    setsessionkey(sess);
  };
  useEffect(() => {
    getSession();
  }, []);

  const handleAgencyConnect = () => {
    window.open(url, '_blank', 'width=600,height=600');
  }
  return (
    <>
      <div className="equalheight d-flex w-100 " style={{
        border: "1px solid rgba(229, 229, 229, 1)",
        background: "white",
        borderRadius: "5px"
      }}   >
        <div className="p-20-px text-black text-bold text-left w-50-per">

          <SoftBox display="flex" alignItems="center">
            <SoftAvatar src={GhlLogo} alt="Slack logo" variant="rounded" />

            <SoftBox ml={2} lineHeight={0}>
              <SoftTypography variant="h5" fontWeight="medium">
                GHL Agency Level Integration
              </SoftTypography>
              <SoftTypography variant="button" color="text" fontWeight="regular">
                Connect your Go High Level agency to Your AI
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </div>
        <div className="p-20-px text-black  text-right w-50-per">
          <SoftBox>
            {agency?.agency_ghl && (
              <button className="btn-new-design-black-addacount font-16" style={{ margin: "0px 20px", padding: "10px 20px", fontSize: "16px" }} onClick={() => navigate(`/${email}/${locationId}/prospect`)}>
                GHL Settings
              </button>
            )}
            <button className="btn-new-design-black-addacount font-16" onClick={handleAgencyConnect} style={{ margin: "0px 0px", padding: "10px 20px", fontSize: "16px" }} color={agency?.agency_ghl ? "success" : "dark"}>
              Connect Agency
            </button>
          </SoftBox>
        </div>
      </div>
    </>
  );
}

export default Accounts;
